<template>
  <div class="books-page-container">
    <section class="hero-book-image">
      <h1>BAMBOO PUZZLES</h1>
      <div class="hero-open-book">
        <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/open-book.png" alt="Open Book" />
      </div>
    </section>
   
    <section class="all-puzzles-container">
      <div class="puzzles-grid-title">
        <h2>EXPLORE ALL PUZZLES</h2>
      </div>
      <div class="all-puzzles-grid">
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Women+of+Valor+Word+Search-+Celebrating+Latina+Women+Veterans.webp"
            alt="Women of Valor Word Search Celebrating Latina Women Veterans book cover image">
          <h3>Women of Valor Word Search</h3>
          <div class="cta-row">
            <a href="https://www.amazon.com/Women-Valor-Word-Search-Celebrating/dp/B0FQCHRG2M/ref=sr_1_2?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-2"><button class="cta-2">BUY
                PUZZLE</button></a>
          </div>
        </div> 
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Women-of-Valor-Word-Search-Celebrating-Asian-Women-Veterans.webp"
            alt="Women of Valor Word Search Celebrating Asian Women Veterans book cover image">
          <h3>Women of Valor Word Search</h3>
          <div class="cta-row">
            <a href="https://www.amazon.com/Women-Valor-Word-Search-Celebrating/dp/B0FQCF2C6D/ref=sr_1_4?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-4"><button class="cta-2">BUY
                PUZZLE</button></a>
          </div>
        </div>
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Mazes.webp"
            alt="Mazes book cover image">
          <h3>Mazes for Adults</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Mazes-Adults-Puzzles-Mindful-Collection/dp/B0FQP7MJ4K/ref=sr_1_18?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-18"><button class="cta-2">BUY
                PUZZLE</button></a>
          </div>
        </div>
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Positive-Vibes-Word-Search.webp"
            alt="Positive Vibes Word Search book cover image">
          <h3>Positive Vibes Word Search</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Positive-Vibes-Word-Search-Mindfulness/dp/B0FP8VHDKF/ref=sr_1_3?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-3"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Word-Search-Relaxation.webp"
            alt="Word Search Relaxation book cover image">
          <h3>Word Search for Relaxation</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Word-Search-Relaxation-Puzzles-Collection/dp/B0FQP8SG5H/ref=sr_1_6?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-6"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Spooky-Word-Hunt.webp"
            alt="Spooky Word Hunt book cover image">
          <h3>Spooky & Sweet October Word Hunts</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Spooky-Sweet-October-Goodness-Collection/dp/B0FRZ7FL5Z/ref=sr_1_9?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-9"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Grateful-Heart-Thoughtful-Words.webp"
            alt="Grateful Hearts Thoughtful Words book cover image">
          <h3>Grateful Hearts Thoughtful Words</h3>
          <div class="cta-row">
            <a href="https://www.amazon.com/Grateful-Hearts-Thoughtful-Words-Thanksgiving/dp/B0FRZ1HLTF/ref=sr_1_11?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-11"><button class="cta-2">BUY
                PUZZLE</button></a>
          </div>
        </div>
        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Joyful-Lights-and-Winter-Nights.webp"
            alt="Joyful Lights and Winter Nights book cover image">
          <h3>Joyful Lights and Winter Nights</h3>
          <div class="cta-row">
            <a href="https://www.amazon.com/dp/B0FS7LZK9Y/ref=sr_1_8?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-8"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Sudoku-Begginers.webp"
            alt="Sudoku Begginers book cover image">
          <h3>Sudoku For Begginers: Easy Level</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Sudoku-Beginners-Easy-Level-Collection/dp/B0FQQRH2PV/ref=sr_1_14?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-14"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

         <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Sudoku-Mixed-Puzzles.webp"
            alt="Sudoku Mixed Puzzles book cover image">
          <h3>Sudoku Mixed Puzzles: Easy to Hard</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Sudoku-Mixed-Puzzles-Mindful-Collection/dp/B0FQQV2VCM/ref=sr_1_16?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-16"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

         <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Sudoku-Challenge.webp"
            alt="Sudoku Challenge book cover image">
          <h3>Sudoku Challenge: Medium Level</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Sudoku-Challenge-Puzzles-Mindful-Collection/dp/B0FQQFG6CW/ref=sr_1_13?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-13"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

        <div>
          <img src="https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/Sudoku-Brain-Training.webp"
            alt="Sudoku Brain Training book cover image">
          <h3>Sudoku Brain Training: Hard Level</h3>
          <div class="cta-row">
            
            <a href="https://www.amazon.com/Sudoku-Brain-Training-Puzzles-Collection/dp/B0FQP7Q99Q/ref=sr_1_15?crid=2DWLLEMXNL517&dib=eyJ2IjoiMSJ9.Jj7cya-2i_jnNPmycbcMfiwlwsJnX1wmdAWJG88gpkwEOvW9Wcu4hmyFpf8Dn8Ubm-p6TU25THRfiKfRVVnjCzsukJCPewSxo6JVplj5nNUtyEVF5HBtpOXhfXHFXkzo0Sju7oWnLzLwiAWSxkHn8A98BaEtmLL3B0aEDBXjqlN9Opts6V9pOtuHq9q-5EYqw8x3pXekLuQ3vCE4OXJ28qzSdJZpcGe7QHZJA5fY2ac.BCLvj68VwjvlJywNi_9CWx5fzD3oUp76jGvBuOXaM8w&dib_tag=se&keywords=quinton+taylor+garcia+books&qid=1758670538&sprefix=quinton+taylor+garcia%2Caps%2C177&sr=8-15"><button
                class="cta-2">BUY PUZZLE</button></a>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'BooksView',
  data() {
    return {
      showModal: false,
      currentLocation: null,
      currentIndex: 0,
      reviews: [
        {
          text: 'A gripping dystopian narrative filled with evocative prose and vivid descriptions. The novel explores themes of leadership, morality, and sacrifice through compelling characters and high-stakes survival.',
          image: 'https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/review_stars.png',
          name0: '- Literary Titan',
          link: 'https://literarytitan.com/2025/01/07/ashes-of-the-city/'
        },
        {
          text: 'An intense and immersive dystopian novel that captivates readers with its powerful storytelling, deep character development, and thought-provoking themes of survival and morality.',
          name1: ' - The US Review of Books',
          link: 'https://www.theusreview.com/reviews-1/Ashes-of-the-City-by-Quinton-Taylor-Garcia.html'
        },
        {
          text: 'A starkly focused yet overlong tale of a clash between moderation versus despotism during an emergency. Readers may find echoes of William Goldings Lord of the Flies or William Butlers The Butterfly Revolution. A thought-provoking YA survival novel that delves into leadership, morality, and human nature in crisis.',
          name: '- Kirkus Reviews',
          link: 'https://www.kirkusreviews.com/book-reviews/quinton-taylor-garcia/ashes-of-the-city/'
        }
      ]
    }
  },
  mounted() {
    this.currentLocation = this.$route.name
    window.scrollTo(0, 0)

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        } else {
          entry.target.classList.remove('show');
        }
      });
    });
    const slidebooksElements = document.querySelectorAll('.slidebooks');
    slidebooksElements.forEach((el) => observer.observe(el));
  },
  methods: {
    open(target) {
      this.currentLocation = target
      this.$router.push({ name: target })
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    nextReview() {
      this.currentIndex = (this.currentIndex + 1) % this.reviews.length;
    },
    prevReview() {
      this.currentIndex = (this.currentIndex - 1 + this.reviews.length) % this.reviews.length;
    },
    changeReview(index) {
      this.currentIndex = index
    },
  }
}
</script>

<style>
.slidebooks {
  opacity: 0;
  transition: all 0.8s;
  transform: translateX(-100%);
}

.show {
  opacity: 1;
  transform: translateX(0);
}

/* Books Container */
.books-page-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Section 1 - Hero Image */
.hero-book-image {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: var(--quarternary);
  background-image: url("https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/bamboo-fence-texture.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  height: 75vh;

  h1 {
    font-size: 88px;
    font-weight: bold;
    text-align: center;
    color: var(--secondary);
  }
}

.hero-open-book {
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 48%;
    margin-top: 72px;
  }
}

/* Sections 2 - All Books Container  */
.all-puzzles-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #BDE3FF;
  background: url(https://bamboovillagebooks.s3.us-east-2.amazonaws.com/images/fantastic-blue-sky.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px 0px 64px 0px;

  h3 {
    margin: 8px 0 24px 0;
  }
}

.all-puzzles-grid {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 88px;
  flex-grow: 1;

  h3 {
    font-size: 15px;
  }

  img {
    border: 1px solid var(--quinary);
  }
}

a {
  text-decoration: none;
}

.dropdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  display: inline-block
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: var(--secondary);
  border: 1px solid var(--quarternary);
  font-weight: bold;
  width: 150px;

  a {
    color: var(--quarternary);
    padding: 12px 16px;
    text-decoration: none;
    font-size: 13px;
  }

  :hover {
    background-color: var(--quarternary);
    color: var(--secondary);
  }
}

.dropdown:hover .dropdown-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dropdown:hover .dropbtn {
  background-color: var(--secondary);
  color: var(--quarternary);
  border: 1px solid var(--quinary);
}

.ashes-cta {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

@media (min-width:768px) and (max-width:1024px) {
  .hero-book-image {
    height: 38vh;

    h1 {
      font-size: 56px;
    }
  }
}

@media (max-width: 767px) {
  .hero-book-image {
    height: 35vh;

    h1 {
      font-size: 35px;
    }

    img {
      margin-top: 20px;
    }
  }

  .hero-open-book {
    img {
      width: 48%;
    }
  }

  .puzzles-grid-title {
    h2 {
      margin-bottom: 32px;
    }
  }

  .all-puzzles-grid {
    gap: 80px;

    img {
      height: 450px;
      width: 300px;
      margin-bottom: 16px;
      /* width: 100%; */
    }

    h3 {
      font-size: 24px;
      margin: 0px 0 16px 0;
    }
  }
}
</style>
